// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorInfoModal_wrapper__8J0TZ","content":"ErrorInfoModal_content__7mILX","buttonStyle":"ErrorInfoModal_buttonStyle__rvJ3K"};